import { useTranslation } from "react-i18next";
import Helpers from "../../utils/helpers";

const CreateInvoiceTop = (props: any) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="grid order-top-color mb-3 px-3">
        <div className="col-12 md:col-3">
          <b>Order #: {props.orderData.orderID}</b>
        </div>
        <div className="col-12 md:col-3">
          Status: <b>{props.orderData.orderStatusName}</b>
        </div>
        <div className="col-12 md:col-3">          
            {t("ordersummary_order_date")} :{" "}
          <b className="mb-1 font-semibold">
            {new Date(props.orderData.createdDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric"
            })}
          </b>
        </div>
        <div className="col-12 md:col-3 text-right left-mobile">
          Amount Paid : <b style={{color:"yellow"}}>{Helpers.formatAmountInINR(props.orderData.amountPaid)}</b>      
        </div>
      </div>
    </>
  );
};

export default CreateInvoiceTop;
